import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { AdornedInputAdornment } from './adorned-input-adornment';
import { AdornedInputIcon } from './adorned-input-icon';
import { AdornedInputInput } from './adorned-input-input';
import { AdornedInputRoot } from './adorned-input-root';
import type { AdornedInputPropsInterface } from './types/adorned-input.types';

/**
 * @since 5.0.0
 */

export const AdornedInput = forwardRef<HTMLDivElement, AdornedInputPropsInterface>(
  (props, forwardedRef) => {
    const { input, startAdornment, endAdornment, ...rest } = props;

    return (
      <AdornedInput.Root ref={forwardedRef} {...rest}>
        {startAdornment || null}
        {input}
        {endAdornment || null}
      </AdornedInput.Root>
    );
  },
) as ForwardRefExoticComponent<AdornedInputPropsInterface> & {
  Root: typeof AdornedInputRoot;
  Adornment: typeof AdornedInputAdornment;
  Input: typeof AdornedInputInput;
  Icon: typeof AdornedInputIcon;
};

AdornedInput.displayName = 'AdornedInput';

AdornedInput.Root = AdornedInputRoot;
AdornedInput.Adornment = AdornedInputAdornment;
AdornedInput.Input = AdornedInputInput;
AdornedInput.Icon = AdornedInputIcon;
